export const ACTION_PREFIX = 'TRUST_DETAILS';

export const actionTypes = {
  UPDATE_TRUST_VALIDATION_RESULT: 'UPDATE_TRUST_VALIDATION_RESULT',
  RESET_TRUST_VALIDATION_RESULT: 'RESET_TRUST_VALIDATION_RESULT',
};
